"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gender = exports.Race = exports.kSupportEmail = exports.adaStandardCare2022URL = exports.escGuidelines2021URL = exports.aspirinUseCVDURL = exports.usTaskForceURL = exports.preventionGuidelines2019URL = exports.paperURL = exports.algorithmURL = void 0;
exports.algorithmURL = "https://aspiringuideresources.s3.amazonaws.com/Aspirin_Guide_algorithm_2022.pdf";
exports.paperURL = "http://jama.jamanetwork.com/article.aspx?articleID=2530006";
exports.preventionGuidelines2019URL = "https://aspiringuideresources.s3.amazonaws.com/2019AHA_ACC_CVD_prevention_guidelines.pdf";
exports.usTaskForceURL = "https://aspiringuideresources.s3.amazonaws.com/Recommendation_+Aspirin_Use_to_Prevent_Cardiovascular_Disease_Preventive_Medication_United_States_Preventive_Services_Taskforce.pdf";
exports.aspirinUseCVDURL = "https://aspiringuideresources.s3.amazonaws.com/aspirin-use-cvd-draft-evidence-review.pdf";
exports.escGuidelines2021URL = "https://aspiringuideresources.s3.amazonaws.com/Visseren_ESC_2021_guidelines_ehab484.pdf";
exports.adaStandardCare2022URL = "https://aspiringuideresources.s3.amazonaws.com/2022_ADA_StandardsofCare.pdf";
exports.kSupportEmail = "AspirinGuide@gmail.com";
var Race;
(function (Race) {
    Race[Race["White"] = 1] = "White";
    Race[Race["Black"] = 2] = "Black";
    Race[Race["Asian"] = 3] = "Asian";
    Race[Race["Hispanic"] = 4] = "Hispanic";
})(Race = exports.Race || (exports.Race = {}));
var Gender;
(function (Gender) {
    Gender[Gender["Male"] = 1] = "Male";
    Gender[Gender["Female"] = 2] = "Female";
})(Gender = exports.Gender || (exports.Gender = {}));
//# sourceMappingURL=ResourceConstants.js.map


/** WEBPACK FOOTER **
 ** ./src/constants/ResourceConstants.js
 **/